HTMLCollection.prototype.forEach = function(callback, thisArg) {
  // Convert the HTMLCollection to an array
  Array.prototype.forEach.call(this, callback, thisArg);
};

window.addEventListener("ss-on-results-load", () => {
  // console.log("Results loaded, attaching event listeners to quick view buttons...");

  const buttons = document.querySelectorAll('.boost-pfs-quickview-btn');

  buttons.forEach(button => {
    // Remove existing event listeners to prevent duplicates
    button.removeEventListener('click', handleQuickViewClick);
    button.addEventListener('click', handleQuickViewClick);
  });
});

function handleQuickViewClick(event) {
  event.preventDefault();

  const quickViewUrl = event.currentTarget.dataset.href;
  const isAbsoluteUrl = quickViewUrl.startsWith('http');
  const fullUrl = isAbsoluteUrl ? quickViewUrl : `${window.location.origin}${quickViewUrl}`;

  // Check if the modal already exists
  let existingBackdrop = document.querySelector('.boost-pfs-modal-backdrop');
  if (existingBackdrop) {
    existingBackdrop.remove();
  }

  fetch(fullUrl, {
    method: 'GET',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
  })
  .then(response => response.text())
  .then(text => {
    const quickviewHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('.boost-pfs-quickview-wrapper').innerHTML;
    const backdrop = document.createElement('div');
    backdrop.classList.add('boost-pfs-modal-backdrop');
    backdrop.innerHTML = `<div class="boost-pfs-modal-container">
                              <div class="boost-pfs-modal-content">
                                  <div class="boost-pfs-quickview-wrapper">${quickviewHTML}</div>
                              </div>
                          </div>`;
    document.body.appendChild(backdrop);
    backdrop.style.display = 'flex';

    // Set pointer-events styles
    backdrop.style.pointerEvents = 'auto';
    backdrop.querySelector('.boost-pfs-modal-container').style.pointerEvents = 'none';
    backdrop.querySelector('.boost-pfs-modal-content').style.pointerEvents = 'auto';

    // Add event listener for close button
    const closeButton = backdrop.querySelector('.boost-pfs-quickview-close');
    if (closeButton) {
      closeButton.addEventListener('click', () => {
        backdrop.remove();
      });
    }

    // Add event listener to close modal when clicking outside of the modal content
    backdrop.addEventListener('click', (e) => {
      if (e.target === backdrop) {
        backdrop.remove();
      }
    });

    // Add resize event listener to close modal on small screens
    window.addEventListener('resize', () => handleResize(backdrop, event.currentTarget));

    initImageSlider(backdrop);

    // Add event listener for the quick view form submission
    const quickViewForm = backdrop.querySelector('#boost-pfs-quickview-cart-form');
    if (quickViewForm) {
      quickViewForm.addEventListener('submit', handleQuickViewFormSubmission);
    }
  })
  .catch(error => {
    console.error('Error fetching quick view content:', error);
  });
}

function handleQuickViewFormSubmission(e) {
  e.preventDefault();
  const form = e.target;
  const variantId = form.querySelector('select[name="id"]').value;
  const quantity = form.querySelector('input[name="quantity"]').value || 1;

  addNewItem(variantId, quantity)
    .then(data => {
      const miniCart = document.querySelector('mini-cart');
      if (miniCart) {
        miniCart.refresh(data);
        miniCart.open(); // Open the minicart
      }

      // Close the quickview modal
      const quickViewModal = document.querySelector('.boost-pfs-modal-backdrop');
      if (quickViewModal) {
        quickViewModal.remove();
      }
    })
    .catch(error => {
      console.error('Error adding item to cart:', error);
    });
}

function handleResize(backdrop, button) {
  if (window.innerWidth < 1200 || window.innerHeight < 650) {
    backdrop.remove();
  }
}

function initImageSlider(modal) {
  const t = modal.querySelector(".boost-pfs-quickview-featured-image-wrapper"),
        e = modal.querySelectorAll(".boost-pfs-quickview-featured-image"),
        n = modal.querySelector(".boost-pfs-quickview-slider-prev"),
        i = modal.querySelector(".boost-pfs-quickview-slider-next"),
        o = modal.querySelectorAll(".boost-pfs-quickview-slider-dot");

  let imageSlider = {
    $itemsWrapper: t,
    $prev: n,
    $next: i,
    $dots: o,
    posX1: 0,
    posX2: 0,
    posInitial: 0,
    posFinal: 0,
    threshold: 50,
    slidesLength: e.length,
    slideSize: e[0].offsetWidth,
    index: 0,
    allowShift: !0,
    isDragging: !1,
    slides: e
  };

  imageSlider.$dots[0].classList.add("active");
  imageSlider.$prev.addEventListener("click", () => {
    imageSlider.index = ((imageSlider.index - 1) > -1) ? imageSlider.index - 1 : imageSlider.slidesLength - 1;
    updateSlider(imageSlider);
  });

  imageSlider.$next.addEventListener("click", () => {
    imageSlider.index = ((imageSlider.index + 1) < imageSlider.slidesLength) ? imageSlider.index + 1 : 0;
    updateSlider(imageSlider);
  });

  imageSlider.$dots.forEach((dot, index) => {
    dot.addEventListener("click", () => {
      imageSlider.index = index;
      updateSlider(imageSlider);
    });
  });
}

function updateSlider(imageSlider) {
  imageSlider.$dots.forEach((item) => {
    item.classList.remove("active");
  });
  imageSlider.slides.forEach((slide) => {
    slide.classList.add("hidden-quick-view");
  });
  imageSlider.slides[imageSlider.index].classList.remove("hidden-quick-view");
  imageSlider.$dots[imageSlider.index].classList.add("active");
}
